import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { CmsEntities } from 'client/data/models/cms';
import { parseContentMetadata } from 'site-modules/shared/utils/parse-content-metadata';
import { Link } from 'site-modules/shared/components/link/link';

export function PopularMakes({ topMakes, className = null, linkTrackingId = null }) {
  const topMakesLinks = parseContentMetadata(topMakes.getAllMetadata(), ['link-url', 'title'], 20);

  return (
    <div className={classnames(className)}>
      <h2 className="heading-3 mb_2">Browse Other Popular Brands</h2>
      <Row tag="ul" className="px-1_25 pt-1_25 bg-cool-gray-100 list-unstyled">
        {topMakesLinks.map(({ linkUrl, title }) => (
          <Col tag="li" xs={3} key={title} className="mb-1_5">
            <Link to={linkUrl} data-tracking-id={linkTrackingId} className="text-blue-30">
              {title}
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}

PopularMakes.propTypes = {
  topMakes: CmsEntities.Content.isRequired,
  className: PropTypes.string,
  linkTrackingId: PropTypes.string,
};
